import React from 'react';
import IndustryPageTemplate from './IndustryPageTemplate';
import image from '../../../assets/ChatGPT Image Aug 24, 2026, 01_57_04 PM.png';

const AiAssistantIndustry = () => {
  return (
    <IndustryPageTemplate
      title="AI Assistant"
      subtitle="Your Smart Creative Partner"
      desc="Your smart creative assistant to help you create faster and better. From scriptwriting to storyboarding, let our AI handle the heavy lifting while you focus on the vision."
      image={image}
      themeColor="#673ab7"
      bgGradient="linear-gradient(135deg, rgba(103,58,183,0.15), rgba(255,255,255,0))"
      features={[
  {
    "title": "AI Content Suggestions",
    "desc": "Overcome writer's block with intelligent plot and dialogue generation."
  },
  {
    "title": "Auto Captions",
    "desc": "Automatically generate perfectly synced subtitles in over 50 languages."
  },
  {
    "title": "Smart Recommendations",
    "desc": "Get actionable feedback on pacing, color grading, and audio mixing."
  },
  {
    "title": "Script & Story Help",
    "desc": "Format your screenplays automatically to industry standards."
  }
]}
    />
  );
};

export default AiAssistantIndustry;
